import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnimationLinear: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAnimationLinear"><Path fillRule="evenodd" clipRule="evenodd" d="M21.4144 4.00003L4.00015 21.4142L2.58594 20L20.0002 2.58582L21.4144 4.00003Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAnimationLinear;
